<nz-modal
  [nzMaskClosable]="false"
  [(nzVisible)]="isVisible"
  [nzTitle]="modalTitle"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  (nzOnCancel)="handleCancel()"
  [nzWidth]="1000"
  (nzAfterOpen)="afterModalOpen()"
  >
  <ng-template #modalTitle>{{ title }}</ng-template>

  <ng-template #modalContent>
    @if (!isMobile) {
      <table>
        <tr>
          <td>
            EAN-Code
          </td>
          <td>
            <div class="ean-field white-space-no-wrap">
              <input [(ngModel)]="eanCode" (ngModelChange)="handleNumberScan()" appPossitiveNumbers #scanField nz-input>
              &nbsp;<button nz-button nzType="primary">
              <i nz-icon nzType="barcode" nzTheme="outline" (click)="handleBarcodeScanner()"></i>
            </button>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          Produktname
        </td>
        <td>
          <input [(ngModel)]="productName" (ngModelChange)="handleProductNameChange()" nz-input>
        </td>
      </tr>
      <tr>
        <td>
          Produktstandort
        </td>
        <td>
          <input [(ngModel)]="location" (ngModelChange)="handleLocationChange()" nz-input>
        </td>
      </tr>
    </table>
    <nz-divider></nz-divider>
  }

  <nz-spin [nzSpinning]="loading">
    @if (locations && locations[0]) {
      @if (isMobile) {
        <div class="text-center">
          <div class="white-space-no-wrap">{{ locations[0].articleName }} {{ locations[0].variantName }}</div>
          <div class="white-space-no-wrap" style="margin-top: 16px;">{{ locations[0].orderNumber }}</div>
          @for (store of locations[0].stores; track store.id) {
            @if (store | isStoreMainOrBbm:false:true) {
              <div class="white-space-no-wrap" style="margin-top: 16px;"><b><span style="font-size: 24px;">{{ store.location ?? 'Kein Lagerplatz' }}</span></b></div>
            }
          }
        </div>
      } @else {
        <nz-row>
          <nz-col nzFlex="24">
            <nz-table appColumnLayout
              id="lagerplatzsuche-results-table"
              nzShowSizeChanger
              [nzData]="locations"
              [nzShowPagination]="false"
              >
              <thead>
                <tr>
                  <th nzColumnKey="productName">Produktname</th>
                  <th nzColumnKey="ean" nzWidth="140px">EAN</th>
                  <th nzColumnKey="orderNumber" nzWidth="130px">Bestellnummer</th>
                  <th nzColumnKey="mhd" nzWidth="150px">MHD</th>
                  <th nzColumnKey="warehouse" nzWidth="160px">Lagerhaus</th>
                  <th nzColumnKey="location" nzWidth="110px">Lagerplatz</th>
                  <th nzColumnKey="stock" nzWidth="80px">Bestand</th>
                  <th nzColumnKey="actions" nzRight nzWidth="70px"></th>
                </tr>
              </thead>
              <tbody>
                @for (location of locations; track location) {
                  @for (store of location.stores; track store) {
                    @if (store | isStoreMainOrBbm) {
                      <tr>
                        <td data-name="Produktname">{{ location.articleName }} {{ location.variantName }}</td>
                        <td data-name="EAN" [class.fw-bold]="location.ean === eanCodeCopy">
                          {{ location.ean }}
                        </td>
                        <td data-name="Bestellnummer">{{ location.orderNumber }}</td>
                        <td data-name="MHD" style="white-space: nowrap;">
                          {{ location.mhd | dateFormat }}
                          <button
                            nz-button
                            nzType="text"
                            (click)="openQuickEditModal(location)"
                            [attr.aria-label]="'MHD bearbeiten: ' + location.articleName"
                            nz-tooltip
                            nzTooltipTitle="MHD bearbeiten"
                          >
                            <i nz-icon nzType="edit"></i>
                          </button>
                        </td>
                        <td data-name="Lagerhaus">{{ store.value }}</td>
                        <td data-name="Lagerplatz">{{ store.location }}</td>
                        <td data-name="Bestand">{{ store.stock }}</td>
                        <td nzRight>
                          <div class="actions">
                            <app-add-edit-article-modal #modal>
                              <span trigger>
                                <app-icon-button
                                  icon="edit"
                                  [ariaLabel]="'Artikel bearbeiten: ' + location.articleName"
                                  (pressed)="modal.showModal($any({ id: location.articleId, name: location.articleName }))"
                                ></app-icon-button>
                              </span>
                            </app-add-edit-article-modal>
                          </div>
                        </td>
                      </tr>
                    }
                  }
                }
              </tbody>
            </nz-table>
          </nz-col>
        </nz-row>
      }
    }
  </nz-spin>
</ng-template>

<ng-template #modalFooter>
  <button nz-button nzType="default" (click)="handleCancel()">Schließen</button>
</ng-template>
</nz-modal>

<nz-modal
  [nzMaskClosable]="false"
  [(nzVisible)]="isQuickEditVisible"
  [nzTitle]="quickEditTitle"
  [nzContent]="quickEditContent"
  [nzFooter]="quickEditFooter"
  (nzOnCancel)="handleQuickEditCancel()"
  [nzWidth]="400"
  >
  <ng-template #quickEditTitle>Schnell MHD ändern</ng-template>

  <ng-template #quickEditContent>
    <nz-spin [nzSpinning]="loading">
      @if (selectedLocation) {
        <div>
          <div class="mb-4">{{ selectedLocation.articleName }} {{ selectedLocation.variantName }}</div>
          <nz-date-picker
            style="width: 100%;"
            [nzFormat]="dateFormat"
            [(ngModel)]="quickEditMhd"
            />
        </div>
      }
    </nz-spin>
  </ng-template>

  <ng-template #quickEditFooter>
    <button nz-button nzType="default" (click)="handleQuickEditCancel()" [disabled]="loading">Abbrechen</button>
    <button nz-button nzType="primary" (click)="saveQuickEditMhd()" [nzLoading]="loading">Speichern</button>
  </ng-template>
</nz-modal>
